import React from 'react';
import { ShowAt } from 'consts/breakpoints';
import { ScrollBox } from 'ds/components/carousels/scroll-box';
import { CardsCarousel } from 'ds/components/carousels/cards-carousel/CardsCarousel';
import { WithCarouselShadow } from './styled';

const CARDS_IN_SLIDE_COUNT = {
  1: 1,
  2: 2,
  3: 2,
  4: 2,
  5: 2,
};

export const LocalWinnersCarousel: React.FC<{ rootNode: React.MutableRefObject<HTMLDivElement> }> = props => {
  const { children, rootNode } = props;

  return (
    <>
      <ShowAt to={2}>
        <div ref={rootNode}>
          <ScrollBox
            autoWidth
            isAnimated
            supressCalculatedHeight
          >
            {children}
          </ScrollBox>
        </div>
      </ShowAt>
      <ShowAt from={3}>
        <WithCarouselShadow ref={rootNode}>
          <CardsCarousel
            hasArrows
            cardsInSlideCount={CARDS_IN_SLIDE_COUNT}
            carouselItemAutoWidth
          >
            {children}
          </CardsCarousel>
        </WithCarouselShadow>
      </ShowAt>
    </>
  );
};
